import Carousel from 'react-bootstrap/Carousel'
import { useNavigate, useParams } from 'react-router-dom'
import AddBulletinIcon from 'assets/images/bulletin/Subtract.svg'
interface ICustomCarouselProps {
    bulletins: IBulletiens[]
    isFuckingManager: () => boolean
}
export default function CustomCarousel({
    bulletins,
    isFuckingManager,
}: ICustomCarouselProps) {
    const navigate = useNavigate()
    const { id } = useParams()
    return (
        <Carousel
            style={{
                height: '150px',
                backgroundColor: '#F2F2F2',
                alignItems: 'center',
                borderRadius: '20px',
            }}
            onClick={() =>
                navigate('/fund/bulletin', {
                    state: {
                        bulletins,
                        isManager: isFuckingManager(),
                        moneyPool: id,
                    },
                })
            }
        >
            {isFuckingManager() && (
                <Carousel.Item
                    style={{ height: '150px', alignItems: 'center' }}
                >
                    <div className=" h-full text-center mx-4 text-sm items-center flex flex-col justify-center ">
                        <img
                            src={AddBulletinIcon}
                            alt="add"
                            className=" mb-3"
                        />
                        <p>اعلان برای اعضای صندوق ثبت کنید</p>
                    </div>
                </Carousel.Item>
            )}
            {bulletins.map((item) => (
                <Carousel.Item
                    key={item.id}
                    style={{ height: '150px', alignItems: 'center' }}
                >
                    <div className=" grid grid-cols-3 h-full mx-4 items-center">
                        <p className=" text-sm col-span-2 line-clamp-3">
                            {item.text}
                        </p>
                        <img
                            src={item.sticker.image}
                            className=" object-fill col-span-1"
                            alt="carousel"
                        />
                    </div>
                </Carousel.Item>
            ))}
        </Carousel>
    )
}
